import { HttpErrorResponse } from '@angular/common/http';
import { EMPTY } from 'rxjs';
import { UserService } from '../services';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '../../auth/services/auth.service';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../services/user.service";
import * as i2 from "@auth0/angular-jwt/src/jwthelper.service";
import * as i3 from "../../auth/services/auth.service";
import * as i4 from "@angular/router";
var ApiInterceptor = /** @class */ (function () {
    function ApiInterceptor(userService, jwtHelper, authService, router) {
        this.userService = userService;
        this.jwtHelper = jwtHelper;
        this.authService = authService;
        this.router = router;
        this.baseUrl = environment.api;
    }
    ApiInterceptor.prototype.intercept = function (request, next) {
        var apiReq = request;
        if (!/^https?:\/\/(.*)/.test(request.url) &&
            !/^assets\/(.*)/.test(request.url)) {
            apiReq = request.clone({ url: this.baseUrl + "/" + request.url });
        }
        var refresh_token = localStorage.getItem(this.authService.REFRESH_TOKEN_KEY);
        apiReq = this.setAccessToken(apiReq);
        if (this.jwtHelper.isTokenExpired() &&
            !/^(.*)refresh-token/.test(request.url) &&
            refresh_token) {
            return this.handleRefreshToken(apiReq, next);
        }
        else {
            return next.handle(apiReq);
        }
    };
    ApiInterceptor.prototype.handleRefreshToken = function (apiReq, next) {
        var _this = this;
        return this.authService.refreshToken().pipe(switchMap(function () {
            apiReq = _this.setAccessToken(apiReq);
            return next.handle(apiReq);
        }), catchError(function (error) {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                _this.authService.logout();
                _this.router.navigate(['/auth'], {
                    queryParams: {
                        redirectTo: document.location.pathname
                    }
                });
            }
            return EMPTY;
        }));
    };
    ApiInterceptor.prototype.setAccessToken = function (apiReq) {
        var accessToken = localStorage.getItem(this.authService.ACCESS_TOKEN_KEY);
        if (accessToken) {
            apiReq = apiReq.clone({
                headers: apiReq.headers.set('Authorization', "Bearer " + accessToken)
            });
        }
        return apiReq;
    };
    ApiInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApiInterceptor_Factory() { return new ApiInterceptor(i0.ɵɵinject(i1.UserService), i0.ɵɵinject(i2.JwtHelperService), i0.ɵɵinject(i3.AuthService), i0.ɵɵinject(i4.Router)); }, token: ApiInterceptor, providedIn: "root" });
    return ApiInterceptor;
}());
export { ApiInterceptor };
